export default __webpack_public_path__ + "images/af38912d0ac5441b3a149e3e58c695c2.jpg";